import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchBrands } from "../../store/slices/brandsSlice";
import {
  Section,
  Container,
  SectionEyebrow,
  SectionTitle,
} from "../ui/Section";
import { MotionItem, fadeUp, fadeUpSmall } from "../ui/Motion";
import { BrandsStripSkeleton } from "../ui/Skeleton";
import { mediaUrl } from "../../utils/media";
import { ReactComponent as PrincessLogo } from "../../assets/icons/princess.svg";
import { ReactComponent as NexLogo } from "../../assets/icons/nex.svg";
import { ReactComponent as RibcoLogo } from "../../assets/icons/ribco.svg";
import { ReactComponent as AzimutLogo } from "../../assets/icons/azimut.svg";
import { ReactComponent as FerrettiLogo } from "../../assets/icons/ferretti.svg";
import { ReactComponent as MaioraLogo } from "../../assets/icons/maiora.svg";
import { ReactComponent as BenettiLogo } from "../../assets/icons/benetti.svg";
import { ReactComponent as SunseekerLogo } from "../../assets/icons/sunseeker.svg";
import {
  Header,
  MarqueeWrapper,
  MarqueeTrack,
  BrandLogo,
  EmptyBrands,
  BrandName,
} from "./styles/BrandsStrip.styles";

const BRAND_LOGO_SVGS = {
  princess: PrincessLogo,
  nex: NexLogo,
  ribco: RibcoLogo,
  azimut: AzimutLogo,
  ferretti: FerrettiLogo,
  maiora: MaioraLogo,
  benetti: BenettiLogo,
  sunseeker: SunseekerLogo,
};

function BrandsStrip() {
  const dispatch = useDispatch();
  const { items: brands, loading } = useSelector((state) => state.brands);

  useEffect(() => {
    if (brands.length === 0) {
      dispatch(fetchBrands());
    }
  }, [dispatch, brands.length]);

  // Repeat track items so the marquee can loop seamlessly. Need enough copies
  // to fill the viewport on wider screens.
  const marqueeBrands =
    brands.length > 0 ? [...brands, ...brands, ...brands, ...brands] : [];

  return (
    <Section $bg="pearl">
      <Container $wide>
        <Header>
          <MotionItem $variants={fadeUpSmall}>
            <SectionEyebrow>Trusted Partners</SectionEyebrow>
          </MotionItem>
          <MotionItem $variants={fadeUp}>
            <SectionTitle>World-Class Brands</SectionTitle>
          </MotionItem>
        </Header>

        {loading ? (
          <BrandsStripSkeleton />
        ) : brands.length === 0 ? (
          <EmptyBrands>No brands available yet.</EmptyBrands>
        ) : (
          <MarqueeWrapper>
            <MarqueeTrack>
              {marqueeBrands.map((brand, i) => {
                const SvgLogo = BRAND_LOGO_SVGS[brand.slug];
                const isClone = i >= brands.length;
                return (
                  <BrandLogo
                    key={`${brand.id}-${i}`}
                    as={Link}
                    to={`/brands/${brand.slug || brand.id}`}
                    aria-hidden={isClone || undefined}
                    tabIndex={isClone ? -1 : 0}
                    data-brand={brand.slug}
                  >
                    {SvgLogo ? (
                      <SvgLogo aria-label={isClone ? undefined : brand.name} />
                    ) : brand.logo ? (
                      <img src={mediaUrl(brand.logo)} alt={brand.name} />
                    ) : (
                      <BrandName>{brand.name}</BrandName>
                    )}
                  </BrandLogo>
                );
              })}
            </MarqueeTrack>
          </MarqueeWrapper>
        )}
      </Container>
    </Section>
  );
}

export default BrandsStrip;
